import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from 'utils/constants/reactQuery';
import { COOKIES, getCookie } from 'utils/helpers';
import { storage } from 'utils/web-storage';

export function getUsrhashOptions({ enabled }: { enabled: boolean }) {
  return queryOptions({
    queryKey: [queryKeys.usrhash],
    queryFn: () => {
      const usrhash = getCookie(COOKIES.SELLIGENT_USRHASH);
      const storageSubscribed = storage.local.get('user_subscribed');
      if (!usrhash) {
        if (storageSubscribed) storage.local.set('user_subscribed', false);
        return null;
      }

      return usrhash;
    },

    enabled,
    placeholderData: null,
    staleTime: Infinity,
  });
}
